import { useEffect, useState } from "react";
import { useLang } from "../context/LangContext";

const DEADLINE = new Date("2026-12-31T23:59:59");
const pad = (n) => String(n).padStart(2, "0");

export const Countdown = () => {
  const { lang, t } = useLang();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, DEADLINE.getTime() - now);
  const values = [
    Math.floor(diff / 86400000),
    Math.floor(diff / 3600000) % 24,
    Math.floor(diff / 60000) % 60,
    Math.floor(diff / 1000) % 60,
  ];
  const labels = lang === "cn" ? ["天", "时", "分", "秒"] : ["Days", "Hours", "Mins", "Secs"];

  return (
    <div data-testid="campaign-countdown" className="flex flex-col items-center">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-slate-400">
        {t.campaign.countdownLabel}
      </p>
      <div className="mt-4 flex gap-2 sm:gap-3">
        {values.map((v, i) => (
          <div
            key={i}
            data-testid={`countdown-unit-${i}`}
            className="min-w-[62px] rounded-xl border border-white/10 bg-white/[0.04] px-2 py-2.5 text-center backdrop-blur sm:min-w-[78px] sm:px-4 sm:py-3"
          >
            <div className="text-gradient font-display text-2xl font-black tabular-nums sm:text-3xl">
              {i === 0 ? v : pad(v)}
            </div>
            <div className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400">
              {labels[i]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const SlimCountdown = () => {
  const { lang } = useLang();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, DEADLINE.getTime() - now);
  const d = Math.floor(diff / 86400000);
  const time = `${pad(Math.floor(diff / 3600000) % 24)}:${pad(Math.floor(diff / 60000) % 60)}:${pad(
    Math.floor(diff / 1000) % 60
  )}`;

  return (
    <div
      data-testid="hero-countdown"
      className="inline-flex items-center gap-2.5 rounded-full border border-amber-400/20 bg-amber-400/[0.06] px-4 py-1.5 backdrop-blur"
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber-400" />
      </span>
      <span
        data-testid="hero-countdown-text"
        className="text-xs font-semibold tabular-nums text-amber-200/90"
      >
        {lang === "cn" ? `限时优惠剩余：${d}天 ${time}` : `Offer Ends In: ${d}D ${time}`}
      </span>
    </div>
  );
};
